import { useMutation } from "@apollo/client/react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import { StatefulButton } from "../../../components/ui/muiButtons";
import { RemoveUserV2Document } from "../../../graphql/types";

const DeleteAccountUser = ({
  userName,
  userEmail,
  accountName,
  accountUrlName,
  isLastAccount,
  onClose,
  onConfirm,
}: {
  userName: string;
  userEmail: string;
  accountName: string;
  accountUrlName: string;
  isLastAccount?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const [removeUser, removeUserState] = useMutation(RemoveUserV2Document, {
    onCompleted: () => {
      toast.success("User removed from account");
      onConfirm();
    },
    onError: () => {
      toast.error("Error when removing user from account");
    },
    refetchQueries: ["userDetails", "account"],
  });
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  const handleConfirm = () => {
    removeUser({
      variables: {
        urlName: accountUrlName,
        email: userEmail,
      },
    });
  };
  return (
    <Dialog
      open
      data-testid="delete-user-account-dialog"
      onClose={() => {
        onClose();
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle variant="heading.four">
        {isLastAccount ? (
          `Deactivate ${userName}`
        ) : (
          <>
            Remove user <b>{userName}</b> from account <b>{accountName}</b>?
          </>
        )}
      </DialogTitle>
      <DialogContent>
        {isLastAccount ? (
          <>
            <DialogContentText sx={{ fontSize: "14px" }}>
              <>
                Account <b>{accountName}</b> is the only account associated with this user. Removing this user from{" "}
                {accountName} will deactivate the user. To confirm, please type <b>remove</b> below
              </>
            </DialogContentText>
            <TextField
              required
              id="removeField"
              type="text"
              autoFocus
              autoComplete="off"
              margin="dense"
              placeholder="Type remove"
              fullWidth
              variant="standard"
              onChange={(e) => {
                if (e.target.value === "remove") {
                  setIsButtonEnabled(true);
                } else {
                  setIsButtonEnabled(false);
                }
              }}
              slotProps={{
                htmlInput: {
                  "aria-label": "Type remove to continue",
                },
              }}
            />
          </>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-testid="cancel-button" variant="outlined">
          Cancel
        </Button>
        <StatefulButton
          onClick={handleConfirm}
          data-testid="confirm-button"
          loading={removeUserState.loading}
          color="error"
          disabled={!isButtonEnabled && isLastAccount}
        >
          Confirm
        </StatefulButton>
      </DialogActions>
    </Dialog>
  );
};
export { DeleteAccountUser };
